// extracted by mini-css-extract-plugin
module.exports = {"root":"RuleSummaryTiles_root__37iUQ","tile":"RuleSummaryTiles_tile__22mHM","header":"RuleSummaryTiles_header__HR2-h","value":"RuleSummaryTiles_value__2qxDL"};